// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1033e2a6","239":"3d4a9092","732":"20d84b10"}[chunkId] + ".chunk.js";
};